import React from "react";
import { useSelector } from "react-redux";

import KPTextform from "../../../../components/KPTComponents/KPTextform";
import { SOLUTIONS_CONSTANTS } from "../../../../constants";
import { getQcvScoreOptions } from "../../../../utils/qcvScoreOptions";
import { Typography } from "@material-ui/core";

export const solutionForm = (
  values,
  mobileMode,
  disabled,
  typeOptions = SOLUTIONS_CONSTANTS.TYPE_OPTIONS,
  // Khi true: chỉ mở 2 trường số tác giả chính / số tác giả, các trường khác
  // vẫn khoá (dùng cho màn duyệt thưởng).
  authorEditable = false
) => [
  {
    key: "title",
    width: 12,
    height: 1,
    label: "Tên sáng chế/giải pháp",
    value: values?.title,
    disabled,
    required: true,
  },
  {
    key: "numberMain",
    width: 12,
    label: "Số lượng tác giả chính (Tác giả đầu, tác giả liên hệ)",
    type: "int",
    value: values?.numberMain,
    disabled: authorEditable ? false : disabled,
    required: true,
  },
  {
    key: "numberAuthor",
    width: mobileMode ? 12 : 4,
    label: "Số tác giả",
    type: "int",
    value: values?.numberAuthor,
    disabled: authorEditable ? false : disabled,
    required: true,
  },
  {
    key: "author",
    width: mobileMode ? 12 : 8,
    height: 1,
    label: "Danh sách tác giả",
    value: values?.author,
    disabled,
    required: true,
  },
  {
    key: "issueBy",
    width: 12,
    height: 1,
    label: "Nơi cấp",
    value: values?.issueBy,
    disabled,
    required: true,
  },
  {
    key: "issueAt",
    width: 5,
    label: "Ngày cấp",
    type: "date",
    value: values?.issueAt,
    disabled,
    required: true,
  },
  {
    key: "type",
    width: 7,
    label: "Phân loại",
    value: values?.type,
    options: typeOptions,
    disabled,
    required: true,
  },
  {
    key: "previewFile",
    disabled,
    required: true,
    width: 12,
    type: "file",
    value: values?.previewFile,
    label: (
      <>
        <Typography variant="body1" style={{ fontSize: 17 }}>
          <b>Upload file minh chứng tại đây</b>
        </Typography>
        <Typography variant="body2" color="secondary">
          Hình ảnh/ file PDF bằng hoặc quyết định được cấp
        </Typography>
        <Typography variant="body2" color="secondary">
          (Có dấu xác nhận của cơ quan có thẩm quyền)
        </Typography>
      </>
    ),
    acceptedFiles: ["image/*", "application/pdf"],
  },
];

export default function SangCheForm(props) {
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  // Mục 1 (bảng điểm QCV): "Phân loại" lấy động từ qcv_score_infos (code 1.x)
  // thay cho SOLUTIONS_CONSTANTS.TYPE_OPTIONS hardcode.
  const typeOptions = getQcvScoreOptions(scoreInformationList, "1");

  const textForm = solutionForm(
    props.values,
    null,
    props.disabled,
    typeOptions.length ? typeOptions : SOLUTIONS_CONSTANTS.TYPE_OPTIONS,
    props.authorEditable
  );
  return <KPTextform {...props} textForm={textForm} />;
}
